import axios, { AxiosPromise, CancelToken } from 'axios';
import { v4 as uuidv4 } from 'uuid';

import { formatUrl, IUrlParams } from '@utils/text';

import { TIMEOUT } from '../constants';
import { httpMethods, IHeader } from '../model';

export interface IHttpClientRequest {
  method: httpMethods;
  path: string;
  restUrlParams?: IUrlParams[];
  queryUrlParams?: IUrlParams[];
  data?: unknown;
  timeout?: number;
  customHeaders?: IHeader[];
  cancelToken?: CancelToken;
}

type THttpClient = (clientBaseUrl: string) => <TResult>(params: IHttpClientRequest) => AxiosPromise<TResult>;

export const httpClient: THttpClient = (clientBaseUrl) => {
  return <TResult>({
    method,
    path,
    restUrlParams,
    queryUrlParams,
    data,
    customHeaders,
    timeout = TIMEOUT,
    cancelToken,
  }: IHttpClientRequest) => {
    const headers = customHeaders?.reduce((requestHeaders, header) => ({ ...requestHeaders, ...header }), {});
    if (headers && (method === httpMethods.POST || method === httpMethods.PUT)) {
      headers['X-Trace-Id'] = uuidv4();
    }

    return axios.request<TResult>({
      url: formatUrl({ urlBase: clientBaseUrl, path: path, restUrlParams, queryUrlParams }),
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        ...headers,
      },
      cancelToken,
      method,
      timeout,
      data,
    });
  };
};
